import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RFilter } from './r-filter.action';

interface RFilterXsStateModel {
  useSmartFilterEmptyDataField: string;
  useSmartFilterDuplicatedSerialNumber: string;
  useSmartFilterEmptySerialNumber: string;
  useSmartFilterJobRoutine: string;
}

const getDefaults = (): RFilterXsStateModel => ({
  useSmartFilterEmptyDataField: null,
  useSmartFilterDuplicatedSerialNumber: null,
  useSmartFilterEmptySerialNumber: null,
  useSmartFilterJobRoutine: null
});

@State<RFilterXsStateModel>({
  name: 'rFilter',
  defaults: getDefaults()
})
@Injectable()
export class RFilterXsState {

  //region SELECTOR

  @Selector()
  static canUseSmartFilterEmptyDataField(state: RFilterXsStateModel): boolean {
    return state.useSmartFilterEmptyDataField != null;
  }

  @Selector()
  static canUseSmartFilterDuplicatedSerialNumber(state: RFilterXsStateModel): boolean {
    return state.useSmartFilterDuplicatedSerialNumber != null;
  }

  @Selector()
  static canUseSmartFilterEmptySerialNumber(state: RFilterXsStateModel): boolean {
    return state.useSmartFilterEmptySerialNumber != null;
  }

  @Selector()
  static canUseSmartFilterJobRoutine(state: RFilterXsStateModel): boolean {
    return state.useSmartFilterJobRoutine != null;
  }

  //endregion

  //region ACTIONS
  @Action(RFilter.SetFilterPrivileges)
  public setFilterPrivileges(ctx: StateContext<RFilterXsStateModel>, action: RFilter.SetFilterPrivileges) {
    const state = ctx.getState();
    const filterPrivileges = [...action.activeUserRightInfoDtoModel.filterPrivileges];

    //find user privilege data model
    const useSmartFilterEmptyDataField = filterPrivileges.find(id => id === UserPrivilegeEnum.USE_SMART_FILTER_EMPTY_DATA_FIELD);
    const useSmartFilterDuplicatedSerialNumber = filterPrivileges.find(id => id === UserPrivilegeEnum.USE_SMART_FILTER_DUPLICATED_SERIAL_NUMBER);
    const useSmartFilterEmptySerialNumber = filterPrivileges.find(id => id === UserPrivilegeEnum.USE_SMART_FILTER_EMPTY_SERIAL_NUMBER);
    const useSmartFilterJobRoutine = filterPrivileges.find(id => id === UserPrivilegeEnum.USE_SMART_FILTER_JOB_ROUTINE);

    //set the state
    ctx.setState({
      ...state,
      useSmartFilterEmptyDataField: useSmartFilterEmptyDataField,
      useSmartFilterDuplicatedSerialNumber: useSmartFilterDuplicatedSerialNumber,
      useSmartFilterEmptySerialNumber: useSmartFilterEmptySerialNumber,
      useSmartFilterJobRoutine: useSmartFilterJobRoutine
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RFilterXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }

  //endregion
}
